// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audit-result .audit .audit-bg img[data-v-6c8143cc],.audit-result .fail .audit-bg img[data-v-6c8143cc]{width:100%}.audit-result .audit .title[data-v-6c8143cc],.audit-result .fail .title[data-v-6c8143cc]{margin-bottom:15px;font-size:20px}.audit-result .audit .tips[data-v-6c8143cc],.audit-result .fail .tips[data-v-6c8143cc]{margin-bottom:50px;font-size:16px}", ""]);
// Exports
module.exports = exports;
